import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getInlineCoach } from 'components/atoms/Coach/Inline';
import { EventCustomFeedbackCodes, EventLevels, EventTypes } from 'defs/events';
import noop from 'helper/noop';
import { actionCreators as eventsAC } from 'store/events';
import { getCoach } from 'store/profile';

import withVirtualPageView from 'components/hoc/withVirtualPageView';
import { WithVirtualPageView } from 'components/hoc/withVirtualPageView';
import { CoachType } from 'types/coach';

type OfflineNotificationPropsType = {
	doAddEvents: (evs: Array<Object>) => void;
	force?: boolean;
	debug?: boolean;
	coach: CoachType;
} & WithVirtualPageView;

export class OfflineNotificationTrigger extends React.Component<OfflineNotificationPropsType> {
	public static displayName = 'OfflineNotificationTrigger';
	public static defaultProps = {
		force: false,
		doAddEvents: noop,
	};

	public show() {
		const { doAddEvents, coach, trackVirtualPageView } = this.props;

		trackVirtualPageView({
			hrco: 'offline',
		});

		doAddEvents([
			{
				eventLevel: EventLevels.NotAvailable,
				code: EventCustomFeedbackCodes.Offline,
				eventType: EventTypes.Feedback,
				closable: false,
				overwrites: {
					image: getInlineCoach('FrontPhone', coach),
				},
			},
		]);
	}

	public componentDidMount(): any {
		if (!this.props.doAddEvents) {
			return;
		}

		this.show();
	}

	public render() {
		return null;
	}
}

export const mapStateToProps = (state) => ({
	coach: getCoach(state) || 'LEO',
});

export const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doAddEvents: eventsAC.doAddEvents,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(withVirtualPageView(OfflineNotificationTrigger));
